import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt alle Benutzergruppen zurück.
 */
export function getUserGroups(): JQueryPromise<modelsGet.IUserGroup[]>
{
    var endpoint = new URI("api/usergroups");

    return api.get<modelsGet.IUserGroup[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt eine Benutzergruppe zurück.
 */
export function getUserGroup(id: number): JQueryPromise<modelsGet.IUserGroup>
{
    var endpoint = new URI("api/usergroups");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IUserGroup>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Benutzer in einer bestimmten Benutzergruppe zurück.
 * @param groupId Die ID einer Gruppe.
 */
export function getUsers(groupId: number): JQueryPromise<modelsGet.IUser[]>
{
    var endpoint = new URI("api/usergroups");
    endpoint.segment(groupId.toString());
    endpoint.segment("users");

    return api.get<modelsGet.IUser[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(person: modelsPost.IUserGroup): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/usergroups/create",
        data: JSON.stringify(person)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, person: modelsPost.IUserGroup): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/usergroups/edit/${id}`,
        data: JSON.stringify(person)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/usergroups/delete/${id}`
    });
}